module.exports = __webpack_public_path__ + "img/minnanonihongo.af220d2b.svg";